<template lang="pug">
	.dropdown-display-object-property
		.dropdown-control(:class="{empty: isAllPropertiesAdded(), active: active}" v-pseudo-modal-show="this._uid + '-dropdown-display-object-property'")
			.value {{isAllPropertiesAdded() ? 'All props added' : 'Add property'}}
			.drop-icon.fa.fa-caret-down
		.dropdown-menu(v-pseudo-modal="this._uid + '-dropdown-display-object-property'" :style="{'max-height': `90vh`}" v-on:mouseover="active = true" v-on:mouseout="active = false")
			.dropdown-item(v-for="prop in props" v-if="!prop.options['displayAlways'] && !displayObject.props.hasOwnProperty(prop.codename)" @click="selectProperty(prop)")
				.property-title {{prop.title}}
				.property-description {{prop.description}}
</template>

<script>
	import Screen from './../../mixins/screen'

	export default {
		name: 'DropdownDisplayObjectProperty',
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		props: {
			displayObject: {
				type: Object,
				default: null
			}
		},
		data() {

			this.props = [];

			return {
				showed: true,
				active: false
			};

		},
		methods: {
			collectData() {

				this.props = _.filter(_.orderBy(Metadata.DisplayObjectProperties, 'priority'), propertyParams => !propertyParams.options.displayObjectTypes || _.includes(propertyParams.options.displayObjectTypes, this.displayObject?.type));

			},
			selectProperty(propertyParams) {

				this.$emit('select', {propertyCodename: propertyParams.codename});

				Broadcast.call("Pseudo Modal Hide", [this._uid + '-dropdown-display-object-property']);

			},
			isAllPropertiesAdded() {

				return !_.find(this.props, prop => !prop.options["displayAlways"] && !this.displayObject.props.hasOwnProperty(prop.codename));

			}
		}
	}
</script>

<style lang="sass">

	.dropdown-display-object-property
		position: relative
		margin-top: 1px
		user-select: none

		.dropdown-control
			border: 1px solid rgba(255, 255, 255, 0.1)
			border-radius: 0.25rem
			background: rgba(255, 255, 255, 0.05) no-repeat
			background-position-x: right 0.75rem
			background-position-y: calc(50% - 1px)
			background-size: 8px 10px
			padding-top: 0.25rem
			padding-bottom: 0.25rem
			padding-right: 2rem
			padding-left: 0.5rem
			color: rgba(255, 255, 255, 0.5)
			cursor: pointer
			font-size: 0.765625rem

			&:hover
				border: 1px solid rgba(255, 255, 255, 0.3)
				background: rgba(255, 255, 255, 0.1) no-repeat

			.value
				max-width: 125px
				overflow: hidden
				text-overflow: ellipsis
				white-space: nowrap

			.drop-icon
				position: absolute
				right: 13px
				top: 8px
				color: rgba(255, 255, 255, 0.50)

		.dropdown-control:hover, .dropdown-control.active
			border: 1px solid #20a8d8
			background: rgba(255, 255, 255, 0.1) no-repeat

			.value, .drop-icon
				color: #20a8d8

		.dropdown-menu
			top: 28px
			border-color: #3f454b
			width: 190px
			margin: 0
			padding: 0

			.dropdown-item
				display: flex
				flex-direction: column
				justify-content: start
				padding: 0.25rem
				padding-left: 0.55rem
				font-size: 0.765625rem
				border-bottom: 1px solid #3f454b
				background-color: #555b5f

				&:last-child
					border-bottom: none

				&:hover
					background-color: #646a6f

				.fa
					display: flex
					align-items: center
					justify-content: center

				.property-title
					color: rgba(255,255,255,1)
					width: 160px
					overflow: hidden
					text-overflow: ellipsis
					margin-left: 0
					white-space: nowrap
					font-size: 13px

				.property-description
					width: 160px
					margin-left: 0
					white-space: normal
					font-size: 11px
					color: rgba(255,255,255,0.4)

		.dropdown-control.empty
			background: rgba(255, 255, 255, 0.00) no-repeat
			background-position-x: right 0.75rem
			background-position-y: calc(50% - 1px)
			background-size: 8px 10px
			color: rgba(255, 255, 255, 0.30)
			padding-right: 0.5rem

			.drop-icon
				display: none

			.dropdown-menu
				display: none

</style>
